import css from "./BasicPage.module.css";
import { Footer, Header } from "../../organism";

export interface BasicPageProps {
  children: JSX.Element | JSX.Element[] | React.ReactNode;
}

const BASE_CLASS = "f-BasicPage";

export const BasicPage = ({ children }: BasicPageProps) => (
  <body className={css[BASE_CLASS]}>
    <Header />
    <main>{children}</main>
    <Footer />
  </body>
);
